/**
 * Route guard: only render children if the user is an invoice approver.
 * Otherwise redirect to /invoices (the submitter dashboard).
 *
 * Mirrors the existing RequireToolAccess pattern. Belt-and-braces — the
 * server-side callables enforce this anyway, but the redirect prevents
 * a confusing "permission denied" error the first time an unauthorized
 * user types the URL.
 */

import { Navigate } from 'react-router-dom';
import { type ReactNode } from 'react';
import { useIsInvoiceApprover } from '../hooks/useIsInvoiceApprover';

export function RequireInvoiceApprover({ children }: { children: ReactNode }) {
  const isApprover = useIsInvoiceApprover();
  if (!isApprover) return <Navigate to="/invoices" replace />;
  return <>{children}</>;
}
